<ng-container *transloco="let t; read: 'profileMapCta'">
  @if (name; as name) {
    <h2 class="mat-headline-5">
      <span [innerHtml]="t(canHaveProperties ? 'blurb' : 'mb-blurb', { name: name | possessive })"></span>
    </h2>
  }

  <rma-map-cta
    [verticalType]="verticalType"
    [mapType]="mapType"
    [mapRequest]="mapRequest"
    [skipCache]="skipCache"
    [mapUrl]="mapUrl"
    [mapUrlParams]="mapUrlParams"
    [target]="target"
    [useHref]="useHref" />
</ng-container>
